import { useEffect, useState } from "react";
import {
  Alert,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { Cartao, Pagina } from "./ui/Painel";
import { CORES } from "../utils/participante";

// Cadastro de convidado feito pela distrital (consome uma vaga da distrital).
const Convidados = () => {
  const [nome, setNome] = useState("");
  const [confirmarPresenca, setConfirmarPresenca] = useState(false);
  const [municipio, setMunicipio] = useState("");
  const [cargo, setCargo] = useState("");
  const [distritais, setDistritais] = useState([]);
  const [distritalId, setDistritalId] = useState("");
  const [mensagem, setMensagem] = useState(null);
  const [enviando, setEnviando] = useState(false);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/distrital/listar`, { credentials: "include" })
      .then((res) => res.json())
      .then((data) => {
        // A distrital interna da inscricao publica nao recebe convites manuais.
        const lista = data.filter((d) => d.nome !== "Distrital Inscricao Publica");
        setDistritais(lista);
        setDistritalId(lista[0]?.id || "");
      })
      .catch((error) => {
        console.error("Erro ao carregar distritais:", error);
        setMensagem({ tipo: "error", texto: "Erro ao carregar distritais." });
      });
  }, []);

  const distritalSelecionada = distritais.find((d) => d.id === distritalId);
  const semVagas = distritalSelecionada && distritalSelecionada.limite_participantes <= 0;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMensagem(null);
    setEnviando(true);

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/participantes/convidados`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          nome,
          municipio,
          cargo,
          confirmar_presenca: confirmarPresenca ? 1 : 0,
          distritalId,
        }),
      });
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Erro ao cadastrar convidado.");
      }

      setMensagem({ tipo: "success", texto: `${nome.trim()} foi cadastrado(a) na lista de convidados.` });
      setDistritais((prev) =>
        prev.map((d) => (d.id === distritalId ? { ...d, limite_participantes: d.limite_participantes - 1 } : d))
      );
      setNome("");
      setMunicipio("");
      setCargo("");
      setConfirmarPresenca(false);
    } catch (err) {
      setMensagem({ tipo: "error", texto: err.message || "Erro ao processar." });
    } finally {
      setEnviando(false);
    }
  };

  return (
    <Pagina
      eyebrow="Evento"
      titulo="Cadastrar convidado"
      descricao="Cada convidado cadastrado usa uma vaga da distrital."
      largura={720}
    >
      <Cartao titulo="Dados do convidado">
        <Box component="form" onSubmit={handleSubmit} sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {mensagem && <Alert severity={mensagem.tipo}>{mensagem.texto}</Alert>}

          <TextField
            select
            label="Distrital"
            size="small"
            fullWidth
            value={distritalId}
            onChange={(e) => setDistritalId(e.target.value)}
            slotProps={{
              select: {
                renderValue: (id) => {
                  const d = distritais.find((item) => item.id === id);
                  return d ? `${d.nome} — ${d.limite_participantes} vagas` : "";
                },
              },
            }}
          >
            {distritais.map((d) => (
              <MenuItem key={d.id} value={d.id} sx={{ fontSize: 13, display: "flex", justifyContent: "space-between", gap: 2 }}>
                <span>{d.nome}</span>
                <Box component="span" sx={{ color: d.limite_participantes > 0 ? CORES.textoSuave : CORES.vermelho, fontSize: 12 }}>
                  {d.limite_participantes} vagas
                </Box>
              </MenuItem>
            ))}
          </TextField>

          {semVagas && <Alert severity="warning">Essa distrital não tem mais vagas disponíveis.</Alert>}

          <TextField
            label="Nome completo"
            size="small"
            fullWidth
            required
            value={nome}
            onChange={(e) => setNome(e.target.value)}
          />
          <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" }, gap: 2 }}>
            <TextField label="Cargo" size="small" fullWidth value={cargo} onChange={(e) => setCargo(e.target.value)} />
            <TextField
              label="Município"
              size="small"
              fullWidth
              value={municipio}
              onChange={(e) => setMunicipio(e.target.value)}
            />
          </Box>

          <FormControlLabel
            control={
              <Checkbox size="small" checked={confirmarPresenca} onChange={(e) => setConfirmarPresenca(e.target.checked)} />
            }
            label={<Typography sx={{ fontSize: 13 }}>Presença já confirmada</Typography>}
          />

          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              type="submit"
              variant="contained"
              disabled={enviando || !nome.trim() || !distritalId || semVagas}
              sx={{ minWidth: 160 }}
            >
              {enviando ? <CircularProgress size={20} color="inherit" /> : "Criar cadastro"}
            </Button>
          </Box>
        </Box>
      </Cartao>
    </Pagina>
  );
};

export default Convidados;
